import { varsFromServer } from '../client_side_injection_vars';

// client side logger
// for API document
// https://github.com/rapid7/le_js/wiki/API

/**
 * Input has two styles, string or object
 * Examples:
 *   logger.log('a message');
 *   logger.info({name: 'bob', email: 'me@example.com'});
 */

const logger = global.LE || {
  log() {},
  info() {},
  error() {},
  warn() {}
};

export default logger;

export function logError(message, error) {
  if (varsFromServer.isProd) {
    window.Rollbar.error(message, error);
    logger.error({ msg: message, err: error });
  } else {
    console.error(message, error); // eslint-disable-line no-console
  }
}
